export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/96e01ad465b776cf7a15ba61a421335e.jpg"
          alt="background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 via-[#0f1117]/50 to-[#0f1117]/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-8 pt-20">
        <div className="w-24 h-24 flex items-center justify-center mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/162592c8-e91d-4939-a85a-6f6f400e30e5.png"
            alt="MELA OOD"
            className="w-full h-full object-contain"
          />
        </div>

        <span className="inline-block text-[#2dd4bf] text-xs tracking-[4px] uppercase font-medium mb-6">
          iOS Application Development
        </span>

        <h1 className="text-5xl md:text-7xl font-thin text-white leading-tight max-w-4xl mb-6">
          <span className="font-semibold">MELA OOD</span>
          <br />
          <span className="text-white/80">Building the future of</span>
          <br />
          <span className="text-[#2dd4bf]">mobile security</span>
        </h1>

        <p className="text-lg text-white/60 max-w-xl leading-relaxed mt-4">
          A team of experts crafting modern iOS applications — VPN and Cleaner solutions designed to enhance user experience and strengthen mobile device security.
        </p>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center pt-2">
            <div className="w-1 h-2 rounded-full bg-white/50" />
          </div>
        </div>
      </div>
    </section>
  );
}
